import viaFlavour from './Assets/flavours/via/flavour';
import viaVanFlavour from './Assets/flavours/viaVan/flavour';
import pickMeUpFlavour from './Assets/flavours/pickMeUp/flavour';
import arrivaClickFlavour from './Assets/flavours/arrivaClick/flavour';
import coolRideFlavour from './Assets/flavours/coolRide/flavour';
import cotaFlavour from './Assets/flavours/cota/flavour';
import bubbleFlavour from './Assets/flavours/bubble/flavour';

const flavours = { via: viaFlavour, pickMeUp: pickMeUpFlavour, arrivaClick: arrivaClickFlavour };

const configByHost = {
    'webapp.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-live.rideraccount.com:4431',
        flavour: viaFlavour,
    },
    'pickmeup-webapp.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-ga.rideraccount.com:4431',
        flavour: pickMeUpFlavour,
    },
    'webapp.viavan.com': {
        backendBaseUrl: 'https://external-webapp-vv.rideraccount.com:4432',
        flavour: viaVanFlavour,
    },
    'arrivaclick-webapp.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-ar.rideraccount.com:4433',
        flavour: arrivaClickFlavour,
    },
    'coolride-webapp.viavan.com': {
        backendBaseUrl: 'https://external-webapp-dbn.rideraccount.com:4435',
        flavour: coolRideFlavour,
    },
    'cota-webapp.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-cota.rideraccount.com:4433',
        flavour: cotaFlavour,
    },
    'bubble-webapp.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-dan.rideraccount.com:4434',
        flavour: bubbleFlavour,
    },
    'hrt-webapp.ridewithvia.com': {
            backendBaseUrl: 'https://external-webapp-hrt.rideraccount.com:4432',
            flavour: viaFlavour,
    },
    'vit-webapp.ridewithvia.com': {
            backendBaseUrl: 'https://external-webapp-vit.rideraccount.com',
            flavour: viaFlavour,
    },
    // development

    'webapp-staging.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-dev.ridewithvia.com:8443',
        flavour: process.env.REACT_APP_FLAVOUR ? flavours[process.env.REACT_APP_FLAVOUR] : viaFlavour,
    },
    'webapp-adhoc.ridewithvia.com': {
        backendBaseUrl: 'https://external-webapp-dev.ridewithvia.com',
        flavour: process.env.REACT_APP_FLAVOUR ? flavours[process.env.REACT_APP_FLAVOUR] : viaFlavour,
    },
    'localhost:3101': {
        backendBaseUrl: 'http://localhost:3100',
        flavour: process.env.REACT_APP_FLAVOUR ? flavours[process.env.REACT_APP_FLAVOUR] : viaFlavour,
    },
};

const flavour = configByHost[window.location.host].flavour;
export const styles = flavour.styles;
export const constants = flavour.constants;
export const strings = flavour.strings;
export const images = flavour.images;

export const BACKEND_BASE_URL = configByHost[window.location.host].backendBaseUrl;
export const GOOGLE_AUTH_TOKEN = 'AIzaSyBHWGSNB5b8jPDRsnjuy_OVFU9b0XBBZpY';

export const PLACE_SUGGESTION_PICKUP_RADIUS_METERS = 10000;
export const PLACE_SUGGESTION_DROPOFF_RADIUS_METERS = 10000;



// WEBPACK FOOTER //
// ./src/config.js